// /Carrossier/FormulaireA/components/shared/InputField.js
import React from "react";

const InputField = ({ 
  section, 
  field, 
  placeholder, 
  type = "text", 
  required = false, 
  formData, 
  handleChange, 
  errors 
}) => {
  const errorKey = `${section}.${field}`;
  
  try {
    return (
      <div>
        <input
          type={type}
          placeholder={placeholder}
          value={formData[section]?.[field] || ""}
          onChange={(e) => handleChange(section, field, e.target.value)}
          className={`w-full px-4 py-3 border rounded-xl bg-white focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-colors ${
            errors[errorKey] ? 'border-red-500' : 'border-gray-200'
          }`}
          required={required}
        />
        {errors[errorKey] && (
          <p className="text-red-500 text-xs mt-1">{errors[errorKey]}</p>
        )}
      </div>
    );
  } catch (error) {
    console.error("❌ Erreur dans InputField:", error);
    return <div className="text-red-500">Erreur d'affichage pour: {placeholder}</div>;
  }
};

export default InputField;